import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const productsToValues = ({ products }) => {
  return (
    products &&
    products.reduce(
      (acc, product) => ({
        ...acc,
        [product.brand]: product.price && product.price.toString(),
      }),
      {},
    )
  );
};

function createValidationSchema(fields) {
  const shape = Object.keys(fields).reduce((acc, key) => {
    acc[key] = Yup.number().required(<FormattedMessage id="general.validation.required" />);
    return acc;
  }, {});
  return Yup.object().shape(shape);
}

export default function DealerProductsForm(props) {
  const initialValues = productsToValues(props);
  const validationSchema = createValidationSchema(initialValues);

  const { onUpdateDealerProducts, onHandleToggleEditMode } = props;

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        onUpdateDealerProducts(values)
          .then(() => {
            onHandleToggleEditMode();
            setSubmitting(false);
          })
          .catch(e => {
            console.log(e);
            setSubmitting(false);
            setErrors({ general: <FormattedMessage id="generic_error_message" /> });
          });
      }}
    >
      {formikProps => {
        return <Form>{props.children(formikProps)}</Form>;
      }}
    </Formik>
  );
}
DealerProductsForm.defaultProps = {
  children: Function,
};
DealerProductsForm.propTypes = {
  children: PropTypes.func,
  onUpdateDealerProducts: PropTypes.func.isRequired,
  onHandleToggleEditMode: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/ProductsForm/ProductsForm.jsx